export default (fillColor: string, strokeColor: string) => {
  return '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n'
    + '<svg\n'
    + '   xmlns:dc="http://purl.org/dc/elements/1.1/"\n'
    + '   xmlns:cc="http://creativecommons.org/ns#"\n'
    + '   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n'
    + '   xmlns:svg="http://www.w3.org/2000/svg"\n'
    + '   xmlns="http://www.w3.org/2000/svg"\n'
    + '   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"\n'
    + '   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"\n'
    + '   version="1.1"\n'
    + '   id="Capa_1"\n'
    + '   x="0px"\n'
    + '   y="0px"\n'
    + '   viewBox="0 0 346.013 346.013"\n'
    + '   style="enable-background:new 0 0 346.013 346.013;width: 80%; height: auto; vertical-align: middle;"\n'
    + '   xml:space="preserve"\n'
    + '   inkscape:version="0.91 r13725"\n'
    + '   sodipodi:docname="alarm_white.svg"><metadata\n'
    + '     id="metadata51"><rdf:RDF><cc:Work\n'
    + '         rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type\n'
    + '           rdf:resource="http://purl.org/dc/dcmitype/StillImage" /><dc:title></dc:title></cc:Work></rdf:RDF></metadata><defs\n'
    + '     id="defs49" /><sodipodi:namedview\n'
    + '     borderopacity="1"\n'
    + '     objecttolerance="10"\n'
    + '     gridtolerance="10"\n'
    + '     guidetolerance="10"\n'
    + '     inkscape:pageopacity="0"\n'
    + '     inkscape:pageshadow="2"\n'
    + '     inkscape:window-width="1618"\n'
    + '     inkscape:window-height="828"\n'
    + '     id="namedview47"\n'
    + '     showgrid="false"\n'
    + '     inkscape:zoom="0.6820553"\n'
    + '     inkscape:cx="173.0065"\n'
    + '     inkscape:cy="173.0065"\n'
    + '     inkscape:window-x="0"\n'
    + '     inkscape:window-y="0"\n'
    + '     inkscape:window-maximized="0"\n'
    + '     inkscape:current-layer="g3" /><g\n'
    + '     id="g3"><path\n'
    + '       d="m 256.76227,220.19006 c -1.77513,-2.69766 -3.45154,-5.24564 -3.98966,-7.46382 -0.042,-0.17861 -0.0911,-0.36128 -0.16237,-0.61436 -2.28354,-7.67647 0.69147,-24.43921 2.46886,-34.45124 0.26788,-1.50394 0.52274,-2.94197 0.75286,-4.29035 0.0232,-0.13675 0.044,-0.27211 0.0724,-0.48006 1.95582,-15.28051 2.58811,-37.91956 -5.51044,-58.99147 -5.6032,-14.57978 -14.45978,-25.82612 -26.3559,-33.48393 1.26598,-9.812938 -4.85967,-19.343691 -14.66682,-22.0511 -9.80715,-2.70741 -19.95724,2.33226 -23.90298,11.405413 -14.1382,0.467533 -27.51111,5.577097 -39.80114,15.219267 -17.76129,13.9298 -28.83431,33.68757 -34.99389,47.80757 l -0.0479,0.11335 c -0.0512,0.12175 -0.0998,0.24114 -0.13249,0.32962 -0.49733,1.28292 -1.01552,2.64514 -1.55689,4.07255 -3.61311,9.51043 -9.66004,25.42824 -15.611995,30.89342 -0.106524,0.10027 -0.208228,0.20187 -0.362362,0.35435 -1.636243,1.66563 -4.382941,2.99463 -7.288979,4.40101 -7.145531,3.45301 -22.013613,10.64166 -17.206389,31.67844 0.929154,4.07105 4.008437,7.29057 8.033861,8.40185 l 167.570804,46.2604 c 4.02253,1.11048 8.31521,-0.0729 11.2052,-3.08958 14.91617,-15.58874 5.84693,-29.38668 1.48625,-36.02133 z"\n'
    + '       id="path5"\n'
    + '       inkscape:connector-curvature="0"\n'
    + '       vector-effect="non-scaling-stroke"\n'
    + `       style="fill:${fillColor}; stroke: ${strokeColor}; stroke-width: 1; " /><path\n`
    + '       vector-effect="non-scaling-stroke"\n'
    + '       d="m 174.26737,259.72378 -38.76399,-10.70137 c -1.59243,-0.43962 -3.28183,-0.15596 -4.63548,0.7754 -2.53909,1.7494 -2.84182,4.93159 -3.02304,6.83188 l -0.0151,0.15247 c -1.22819,12.67106 6.79854,24.33046 19.08688,27.72284 12.51583,3.45518 25.8324,-2.91586 30.9681,-14.80385 l 0.0935,-0.19205 c 0.52305,-1.06418 1.74613,-3.55554 0.50882,-6.31116 -0.44302,-0.98439 -1.5794,-2.74529 -4.21964,-3.47416 z"\n'
    + '       id="path7"\n'
    + '       inkscape:connector-curvature="0"\n'
    + `       style="fill:${fillColor}; stroke: ${strokeColor}; stroke-width: 1;" /></g><g\n`
    + '     id="g17" /><g\n'
    + '     id="g19" /><g\n'
    + '     id="g21" /><g\n'
    + '     id="g23" /><g\n'
    + '     id="g25" /><g\n'
    + '     id="g27" /><g\n'
    + '     id="g29" /><g\n'
    + '     id="g31" /><g\n'
    + '     id="g33" /><g\n'
    + '     id="g35" /><g\n'
    + '     id="g37" /><g\n'
    + '     id="g39" /><g\n'
    + '     id="g41" /><g\n'
    + '     id="g43" /><g\n'
    + '     id="g45" /></svg>';
};
